import { selectBasketSelectedWarehouses } from 'containers/OrderDetails/basketSlice'
import React, { useEffect, useState } from 'react'
import useShopParams from './useShopParams'
import { shopproducts } from 'rest/urls'
import { useReduxSelector } from 'store'
import { POST } from 'rest/request'

interface SelectedWarehouse {
  placeId: string
  cartId: string
  hash: string
  id?: string
}

interface Data {
  id: string
  name: string
  products: shop.ShopItem[]
}

const useShopData = (
  selectCategoryKey?: React.Dispatch<React.SetStateAction<string>>
) => {
  const { cartId, warehouseId, equipmentId } = useShopParams()
  const selectedWarehouses = useReduxSelector(selectBasketSelectedWarehouses)
  const [data, setData] = useState<Data[] | null>(null)
  const [isLoading, setLoading] = useState(false)

  const fetchMagDetails = async (body: object | undefined, equipmentId?: string, callback?: (_: string) => void) => {
    setLoading(true)
    try {
      const url = equipmentId ? `${shopproducts}/${equipmentId}` : shopproducts
      const response = await POST(url, { body })
      if (Array.isArray(response)) {
        setData(response)
        callback?.(response?.[0]?.id)
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const prepareBody = (_selectedWarehouses: SelectedWarehouse[], _cartId?: string, _warehouseId?: string) => {
    const selectedWarehouse = (_cartId && _selectedWarehouses.length > 0)
      ? _selectedWarehouses.find(w => w.cartId === _cartId)
      : undefined

    if (selectedWarehouse?.id || _warehouseId) {
      return {
        related: {
          object: 'Warehouse',
          id: selectedWarehouse?.id || _warehouseId
        }
      }
    }

    if (selectedWarehouse) {
      return {
        related: {
          object: 'Warehouse',
          hash: selectedWarehouse.hash,
          placeId: selectedWarehouse.placeId,
        }
      }
    }
  }

  useEffect(() => {
    const body = prepareBody(selectedWarehouses, cartId, warehouseId)
    fetchMagDetails(body, equipmentId, selectCategoryKey)
  }, [cartId, warehouseId, equipmentId, selectedWarehouses, selectCategoryKey])

  return {
    data,
    isLoading
  }
}

export default useShopData